/**
 * Feature flag utility for checking localStorage-based feature flags
 * Following the pattern from landtrust repository
 */

/**
 * Check if a feature flag is enabled
 * @param flag - The feature flag key to check (e.g., 'feature_flag:SIGNUP_REQUIRED')
 * @returns true if the flag value in localStorage is 1, false otherwise
 */
export const isFeatureFlagEnabled = (flag: string): boolean => {
  try {
    const value = JSON.parse(localStorage.getItem(flag) || 'null');
    return value === 1;
  } catch (e) {
    return false;
  }
};
